import type { ReceiptTemplate } from '../schema';

export const staplesTemplate: ReceiptTemplate = {
  id: 'staples',
  name: 'Staples Receipt',
  brand: 'STAPLES',
  description: 'Staples office supplies store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'staples-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/staples.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'staples-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'staples-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'COPY PAPER 10 REAM', quantity: '1', price: '54.99', sku: '847291034' },
          { id: '2', name: 'SHARPIE MARKERS 12PK', quantity: '1', price: '12.99', sku: '847291035' },
          { id: '3', name: 'FILE FOLDERS 100CT', quantity: '1', price: '14.99', sku: '847291036' },
          { id: '4', name: 'STAPLER HEAVY DUTY', quantity: '1', price: '24.99', sku: '847291037' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'staples-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '107.96', isBold: false, isLarge: false },
          { id: 'rewards', label: 'REWARDS SAVINGS', value: '-5.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '8.49', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '111.45', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'staples-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'staples-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'STAPLES REWARDS MEMBER\nYOU SAVED $5.00!\n\nReturns within 30 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

